"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var resolveQueryStringToRecipient_1 = require("./resolveQueryStringToRecipient");
var setForceResolveState_1 = require("./setForceResolveState");
var legacy_1 = require("satcheljs/lib/legacy");
// Using a "global" timer for this case since we want to kill any search within the timeout scope.
var currentTimeout = null;
var DEBOUNCE_TIMEOUT = 150;
var resolveQueryStringDebounce = function (recipientWell, isLastCharSemiColon) { return function () {
    currentTimeout = null;
    resolveQueryStringToRecipient_1.default(recipientWell, isLastCharSemiColon /**shouldDirectlyResolve */);
}; };
exports.default = legacy_1.action('updateFindControlQueryString')(function updateFindControlQueryString(recipientWell, inputText) {
    if (currentTimeout) {
        clearTimeout(currentTimeout);
    }
    // If the user is typing, we should reset forceResolve state, just in case.
    setForceResolveState_1.default(recipientWell, false /* inForceResolve */);
    // Set the first result to highlighted, if nothing else is.
    if (recipientWell.findResultHightlightIndex == -1) {
        recipientWell.findResultHightlightIndex = 0;
    }
    // Check if last char is semi-colon and if so, remove it from query string.
    var lastCharIndex = inputText.length - 1;
    var lastChar = inputText[lastCharIndex];
    var isLastCharAKnownDelimiter = lastChar == ';' || lastChar == ',';
    if (isLastCharAKnownDelimiter) {
        inputText = inputText.substring(0, lastCharIndex);
    }
    recipientWell.queryString = inputText;
    // Directly resolve if user explicitly typed semi-colon at the end.
    currentTimeout = setTimeout(resolveQueryStringDebounce(recipientWell, isLastCharAKnownDelimiter /**shouldDirectlyResolve */), DEBOUNCE_TIMEOUT);
});
//# sourceMappingURL=updateFindControlQueryString.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/updateFindControlQueryString.js
// module id = 3398
// module chunks = 2 3